import { render, staticRenderFns } from "./ComponentshelterDetail.vue?vue&type=template&id=64df6ec6&"
import script from "./ComponentshelterDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentshelterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports